import { useEffect } from "react";
import ReactGA from "react-ga4";

export const useSEO = () => {
  useEffect(() => {
    // 1. Google Analytics
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    // 2. Metadata
    document.title = "Andri Sebastian | Technology Consultant";
    const meta = document.querySelector('meta[name="description"]') || document.createElement("meta");
    meta.name = "description";
    meta.content = "Professional Technology Consultant & Software Developer based in Jakarta. Expert in .NET Ecosystem, Database Optimization, and Cloud Infrastructure.";
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(meta);

    // 3. Schema Markup
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Andri Sebastian Sibarani",
      jobTitle: "Technology Consultant",
      url: "https://andrisebastian.id",
      sameAs: ["https://github.com/andrisibarani", "https://linkedin.com/in/andrisebastian"],
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "json-ld-schema";
    script.innerHTML = JSON.stringify(schemaData);
    
    const existingScript = document.getElementById("json-ld-schema");
    if (existingScript) existingScript.remove();
    document.head.appendChild(script);

    return () => {
      if (existingScript) existingScript.remove();
    };
  }, []);
};